import { render, staticRenderFns } from "./Icon.vue?vue&type=template&id=04999da0"
import script from "./Icon.vue?vue&type=script&lang=js"
export * from "./Icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04999da0')) {
      api.createRecord('04999da0', component.options)
    } else {
      api.reload('04999da0', component.options)
    }
    module.hot.accept("./Icon.vue?vue&type=template&id=04999da0", function () {
      api.rerender('04999da0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/MultiSelectionBadge/Icon.vue"
export default component.exports